import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { CustomModal } from 'components/customModal';
import { useGetAvailableMasks } from 'api/invite/hooks';
import { Expand } from 'lucide-react';
import { getHighestOrderImageUrl } from 'utils';
import Styles from './maskSelection.module.scss';
import { MaskGalleryView } from './maskGalleryView';

const placeholderImage = 'https://fareedbookcentre.com/cdn/shop/files/Untitleddesign_7.webp?v=1732633338';

export const MaskSelection = ({
	heading,
	reserveMask,
	disableReserveButton,
	guestInvite = false,
	guestCampaignInviteID = ''
}) => {
	const [searchParams] = useSearchParams();
	const restaurantID = searchParams.get('restaurantID');
	const campaignID = searchParams.get('campaignID');
	const campaignInviteID = searchParams.get('campaignInviteID');
	const [selectedMask, setSelectedMask] = useState(null);
	const [isGalleryOpen, setIsGalleryOpen] = useState(false);

	const { data, isPending } = useGetAvailableMasks({
		restaurantID,
		campaignID
	});

	let availableMasks = [];

	availableMasks = data
		&& data.campaign_rewards.length > 0
		&& data.campaign_rewards.filter(
			(r) => r.quantity_available > 0
				&& r.campaign_reward_images
				&& r.campaign_reward_images.length > 0
		);

	return (
		<>
			<div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
				<h3>{heading || 'A masquerade ball starts with a perfect mask'}</h3>
				<button
					disabled={!selectedMask || !selectedMask.id || disableReserveButton}
					onClick={() => reserveMask({
						restaurantID,
						campaignID,
						campaignInviteID: guestInvite ? guestCampaignInviteID : campaignInviteID,
						campaignRewardID: selectedMask.id
					})}
					className={Styles.reserverButton}>
					{guestInvite ? 'Reserve Mask' : 'Reserve my mask'}
				</button>
			</div>
			<div className={Styles.maskList}>
				{isPending && Array.from({ length: 8 }).map(() => (
					<div className={Styles.skeleton} />
				))}

				{(!isPending && (!availableMasks || !availableMasks.length > 0))
					&& <h5>No mask available currently</h5>}

				{!isPending && availableMasks && availableMasks.length > 0 && availableMasks.map((m) => (
					<div
						key={m.id}
						className={Styles.maskContainer}
						onClick={() => setSelectedMask(m)}
					>
						<img
							className={`${Styles.maskImage} ${selectedMask?.id === m.id ? Styles.selected : ''}`}
							src={getHighestOrderImageUrl(m.campaign_reward_images) || placeholderImage}
							alt={`mask-${String(m.description).slice(0, 70)}`}
						/>
						<button
							className={Styles.expandIcon}
							onClick={(e) => {
								e.stopPropagation();

								setSelectedMask(m);
								setIsGalleryOpen(true);
							}}
						>
							<Expand color='grey' size={20} />
						</button>
					</div>
				))}
			</div>
			<CustomModal
				show={isGalleryOpen}
				onClose={() => setIsGalleryOpen(false)}
			>
				<MaskGalleryView
					maskImages={
						selectedMask?.campaign_reward_images
							? [...selectedMask.campaign_reward_images].sort(
								(a, b) => a.image_order - b.image_order
							)
							: []
					}
				/>
			</CustomModal>
		</>
	);
};
